export const SUCCESS_MESSAGES = {
  AGREEMENTS: {
    NEW_AGREEMENT_SUCCESS: 'Acordo gerado com sucesso.'
  }
};
